import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { appConfig } from './app.config';
import './app/common/input-mask-fix';
import './app/common/tiered-menu-fix';

registerLocaleData(localeRu, 'ru');

bootstrapApplication(AppComponent, { ...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers] }).catch((err) => console.error(err));
